export const CORE_STATUSES = [
  'Eccellente',
  'In target',
  'Fuori target',
  'Critico',
] as const;

export type CoreStatus = (typeof CORE_STATUSES)[number];

export type KpiStatus =
  | CoreStatus
  | 'Sotto target'
  | 'Manca dato'
  | 'Da definire'
  | 'No target';

export type TrendDirection =
  | 'In crescita'
  | 'In diminuzione'
  | 'Stabile'
  | string;

export interface RegistryRow {
  Codice: string;
  Nome: string;
  Prospettiva_BSC: string;
  Descrizione_KPI: string;
  Obiettivo_Strategico_Collegato: string;
  Responsabile: string;
  Formula_di_Calcolo: string;
  Unità_di_Misura: string;
  Raggruppamento: string;
  Fonte_Dati: string;
  Frequenza_Rilevazione: string;
  Valore_Baseline: unknown;
  Soglia_Minima: unknown;
  Target: unknown;
  Soglia_Eccellenza: unknown;
  Trend_Desiderato: TrendDirection;
  Metodo_Raccolta_Dato: string;
  Validatore_Dato: string;
  Rischi_di_misurazione: string;
  Note: string;
  Azioni_correttive: string;
  [key: string]: unknown;
}

export type ValueRecordType = 'manuale (Excel)' | 'imported' | 'calculated';

export interface ValueRow {
  period: string;
  kpi_code: string;
  value: number | null;
  dimension_type: string;
  dimension_value: string;
  source_file: string | null;
  note: string | null;
  record_type: ValueRecordType;
  source_order: number;
}

export interface BscDataBundle {
  registry: RegistryRow[];
  values: ValueRow[];
}

export interface SnapshotRow extends RegistryRow {
  period: string | null;
  value: number | null;
  dimension_type: string | null;
  dimension_value: string | null;
  source_file: string | null;
  note: string | null;
  record_type: ValueRecordType | null;
  Status: KpiStatus;
  Valore_visualizzato: string;
  Target_visualizzato: string;
  Ultimo_aggiornamento: string;
  Ordinamento_Prospettiva: number;
  multiline_status_counts?: Partial<Record<KpiStatus, number>>;
}

export interface LineStatusRow {
  dimension_value: string;
  period: string;
  value: number;
  line_status: KpiStatus;
}

export interface LoadedBscData {
  bundle: BscDataBundle;
  snapshot: SnapshotRow[];
  loadedAt: Date;
}

export interface DashboardFilters {
  perspectives: string[];
  statuses: KpiStatus[];
  query: string;
}
